export default __webpack_public_path__ + "static/media/css.5491a3b0.png";